var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloudArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 7.9875,
    height: 11.1714,
    viewBox: "0 0 7.9875 11.1714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.69471 3.87836C7.88219 3.69083 7.9875 3.43652 7.9875 3.17136C7.9875 2.9062 7.88219 2.65189 7.69471 2.46436L6.10871 0.878359C5.54613 0.315946 4.78321 0 3.98771 0C3.19222 0 2.42929 0.315946 1.86671 0.878359L0.280712 2.46436C0.0985537 2.65296 -0.00224062 2.90556 3.78027e-05 3.16776C0.00231622 3.42996 0.107485 3.68077 0.292893 3.86618C0.478301 4.05159 0.729114 4.15676 0.991311 4.15903C1.25351 4.16131 1.50611 4.06052 1.69471 3.87836L2.98771 2.58536V10.1714C2.98771 10.4366 3.09307 10.6909 3.28061 10.8785C3.46814 11.066 3.7225 11.1714 3.98771 11.1714C4.25293 11.1714 4.50728 11.066 4.69482 10.8785C4.88236 10.6909 4.98771 10.4366 4.98771 10.1714V2.58536L6.28071 3.87836C6.46824 4.06583 6.72255 4.17115 6.98771 4.17115C7.25288 4.17115 7.50719 4.06583 7.69471 3.87836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudArrow);
export default __webpack_public_path__ + "static/media/icon_cloud_arrow.46dce9dfbef806a34f07be05839f51dc.svg";
export { ForwardRef as ReactComponent };